var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-results"},_vm._l((_vm.items),function(item,index){return _c('ItemResultDefault',{key:index,attrs:{"item":item,"domain-name":_vm.domainName},on:{"more":function($event){return _vm.$emit('more', ...arguments)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }